module.exports = __webpack_public_path__ + "static/media/cover_banner.4568bf98.jpg";